module.exports = __webpack_public_path__ + "static/logo-61a7fc0f245c8155b6f1a24f55701e8d.svg";